import Common from '../../Common';

const Queues = class extends Common {
	async browse(companyId: id) {
		return this.get(`/company/${companyId}/queues`);
	}

	async browseAll(companyId: id) {
		return this.get(`/company/${companyId}/queues/all`);
	}
}

export default Queues
